import React, { useState, useEffect } from 'react'
import { getSubscriptionDataByFundName } from '../../../components/FundDetails/Data/FundDetailsDataSource.js'
import { isLoggedIntoSubscriptionCenter } from '../../../global/authentication/authentication-manager.js'
import { BehaviorSubject } from 'rxjs'
import {
  getSubscriptionsForUser,
  getStorageProfile,
} from '../../../components/EmailSubscriptionCenter/Data/SubscriptionCenterDataSource.js'
import { updateFundData } from '../../../components/EmailSubscriptionCenter/Landing/Helper/helper.js'
import SubscribeModalButton from '../../../components/EmailSubscriptionCenter/Modal/SubscribeModalButton.jsx'
import EmailSubscriptionCenterModal from '../../../components/EmailSubscriptionCenter/Modal/EmailSubscriptionCenterModal.jsx'
import Loader from '../../../components/FundDetails/Modules/Shared/Loader.jsx'
import './Accordion.css'
import { scrollToElement } from '../../../global/_utils.js'

let ctiUserData = null
const Accordions = ({ page, component, onlyOne }) => {
  const [data, setData] = useState()
  const [expand, setExpand] = useState({})
  const [showModal, setShowModal] = useState(false)

  const [subscriptions, setSubscriptions] = useState([])
  const [subscriptionProfile, setSubscriptionProfile] = useState({ value: {} })
  const [selectedFundSubscriptions, setSelectedFundSubscriptions] = useState({})

  const queryFundsForSubscriptionCenter =
    component?.getParameters().queryFundsForSubscriptionCenter

  if (!ctiUserData) {
    ctiUserData = new BehaviorSubject({})
  }

  useEffect(() => {
    const ctiUserDataInt = ctiUserData.subscribe((payload) => {
      setSubscriptionProfile(payload)
    })
    return () => ctiUserDataInt.unsubscribe()
  }, [])

  async function getUserProfileData() {
    if (onlyOne) {
      const _subscriptionProfile = await getSubscriptionsForUser()
      ctiUserData.next({
        value: {
          ...getStorageProfile(),
          ..._subscriptionProfile.value,
        },
      })
    }
  }

  useEffect(() => {
    const _models = component?.getModels() || {}
    const { document: _documentRef } = _models
    const _document = _documentRef && page?.getContent(_documentRef)
    setData(_document?.getData())

    if (window.location.search) {
      const urlParams = new URLSearchParams(window.location.search)
      const expandParam = (urlParams.get('expand') || '').toLowerCase()

      _document?.getData().outerAccordionCompound.map((outer) => {
        if (
          outer.contentBlock
            .map((inner) => {
              return inner.innerLabel
                ?.replaceAll(' ', '')
                .replaceAll('.', '')
                .toLowerCase()
            })
            .includes(expandParam)
        ) {
          setExpand({ outer: outer.outerLabel, inner: expandParam })
          setTimeout(() => {
            const element = document.querySelectorAll(`#${expandParam}`)[0]
            if (element) {
              scrollToElement(element, 400, -140)
            }
          }, 1000)
        } else if (
          outer.outerLabel
            ?.replaceAll(' ', '')
            .replaceAll('.', '')
            .toLowerCase() === expandParam
        ) {
          setExpand({ outer: outer.outerLabel })
        }
      })
    }
  }, [])

  async function fetchSubscriptionDataByFundName() {
    const fundPortfolioData = data?.outerAccordionCompound.reduce(
      (prev, curr) => {
        if (curr.contentBlock[0].innerLink) {
          return [
            ...prev,
            ...curr.contentBlock.reduce((prev, curr) => {
              return [...prev, curr.innerLabel]
            }, []),
          ]
        } else {
          return [...prev, curr.outerLabel]
        }
      },
      []
    )

    if (fundPortfolioData) {
      let portfolioDataSubscriptionList =
        await getSubscriptionDataByFundName(fundPortfolioData)

      if (isLoggedIntoSubscriptionCenter()) {
        if (
          !subscriptionProfile.value ||
          Object.keys(subscriptionProfile.value).length === 0
        ) {
          await getUserProfileData()
        }
        if (portfolioDataSubscriptionList?.length > 0) {
          portfolioDataSubscriptionList = updateFundData(
            portfolioDataSubscriptionList,
            subscriptionProfile.value
          )
        }

        for (const subscription of portfolioDataSubscriptionList) {
          if (subscription.activeLiterature) {
            subscription.literature = subscription.activeLiterature
          }
        }
      }

      setSubscriptions(portfolioDataSubscriptionList)
    }
  }

  useEffect(() => {
    fetchSubscriptionDataByFundName()
  }, [data, subscriptionProfile.value])

  // ****************************************************** for each SATELLITE SUBSCRIBE BUTTON  ******************************************************
  // render subscribe button for each document (fact sheet, commentary, etc...) within each fund
  const renderSubscribeButton = (link, label, links) => {
    for (const subscription of subscriptions) {
      for (const [index, literature] of subscription.literature.entries()) {
        if (
          subscription.name === label &&
          link.text.indexOf(literature.name) >= 0
        ) {
          const subs = subscription?.literature?.filter((l) =>
            links?.some((i) => i.text?.indexOf(l?.name) >= 0)
          )
          return (
            <SubscribeModalButton
              fundName={subscription.name}
              subscriptionProfile={subscriptionProfile}
              useUnlabeledButton={false}
              useInlineButton={false}
              subs={subs}
              useCheckBoxButton={true}
              currentDoc={literature}
              handleClicked={(d) =>
                subscribeBtnCallback(d, subscription, index)
              }
            />
          )
        }
      }
    }
  }

  const subscribeBtnCallback = (_doc, subscription, index) => {
    if (isLoggedIntoSubscriptionCenter()) {
      const _selectedSubs = { ...subscription }
      _selectedSubs.literature[index].selected = _doc.selected
      setSelectedFundSubscriptions(_selectedSubs)
    }
  }

  const closeModal = () => {
    setShowModal(false)
    //window.location.reload()
  }

  const handleMainSubscribeClick = (subscriptions, inner) => {
    const _selectedFundSubscriptions = subscriptions?.filter(
      (subscription) => subscription?.name === inner?.innerLabel
    )[0]

    if (!isLoggedIntoSubscriptionCenter()) {
      if (
        _selectedFundSubscriptions.literature &&
        _selectedFundSubscriptions.literature.length > 0
      ) {
        _selectedFundSubscriptions.literature = [
          ..._selectedFundSubscriptions.literature,
        ]
        _selectedFundSubscriptions.literature[0].selected = true
      }
    }

    setShowModal(true)
    setSelectedFundSubscriptions(_selectedFundSubscriptions)
  }

  const renderMainSubscribeButton = (subscriptions, inner) => {
    const currentFund = subscriptions?.filter(
      (subscription) => subscription?.name === inner?.innerLabel
    )[0]
    const hasSelected = currentFund?.literature?.some((c) => c?.selected)

    const mainSubscribeButtonText = hasSelected ? 'Subscribed' : 'Subscribe'

    return (
      <button
        className="Button Button--secondary Button--block u-sm-sizeFull js-subcribeButton"
        name={mainSubscribeButtonText}
        data-subscribe={inner.innerLabel}
        data-analytics="cesc-subscribe-link"
        data-qa-automation="subscribe-button"
        onClick={() => handleMainSubscribeClick(subscriptions, inner)}
      >
        <span className="Icon--material u-marginRight1gu u-textSizeMsrp2 u-posRelative">
          mail_outline
          {hasSelected && (
            <span className="Icon--material u-posAbsolute u-textColorWhite u-bgColorConfirm u-textSizeMsrm2 u-textBold Subscribed-icon--stacked">
              check
            </span>
          )}
        </span>
        {mainSubscribeButtonText}
      </button>
    )
  }

  const getFileLink = ({ string, $ref }) => {
    if ($ref) {
      const fileRef = $ref.split('/')[2]
      const urle = page?.model?.page[fileRef]
      return urle?.links?.site?.href || ''
    } else {
      return string
    }
  }

  return subscriptions ? (
    <div className="u-sizeConstrained">
      <div className="Accordion-spa-container u-bgColorWhite u-marginVert10gu">
        <h1 className="u-paddingBottom6gu u-textSizeMsrp2">
          {data?.sectionTitle.toUpperCase()}
        </h1>
        {showModal && (
          <EmailSubscriptionCenterModal
            docs={selectedFundSubscriptions?.literature}
            subscriptions={[]}
            handleCloseModalClick={closeModal}
            isLoggedIn={isLoggedIntoSubscriptionCenter()}
            name={selectedFundSubscriptions?.name}
          />
        )}
        {queryFundsForSubscriptionCenter && <div id="esc-modal-render"></div>}
        <div className="Accordion Accordion--ruled">
          {data?.outerAccordionCompound.map((outer, idx) => (
            <details
              key={idx}
              className="Accordion-item"
              open={outer.outerLabel === expand.outer}
            >
              <summary
                id={outer.outerLabel.replaceAll(' ', '').toLowerCase()}
                className="Accordion-toggle u-textSizeMsrp1"
              >
                {outer.outerLabel}
              </summary>
              {outer.contentBlock.map((inner, idx) => {
                return (
                  <div className="Accordion-content Content" key={idx}>
                    {inner.value && (
                      <div
                        className="Accordion Accordion--ruled"
                        dangerouslySetInnerHTML={{
                          __html: inner.value,
                        }}
                      ></div>
                    )}
                    {inner.text && inner.icon === 'email' && (
                      <a
                        className="u-textBold u-textColorBrand u-textNoTransform u-textSecondary"
                        href={inner.link[0]?.string}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {inner.text}
                        <span className="Icon--material u-marginRight1gu u-textSizeMsrp2">
                          mail_outline
                        </span>
                      </a>
                    )}
                    {inner.links && (
                      <div className="Grid Grid--withGutter u-paddingTop3gu">
                        <div className="u-size2of3">
                          <h2 className="u-textBold u-marginBottom1gu">
                            {inner.tableHeader}
                          </h2>
                          {inner.links.map((link, idx) => (
                            <div key={idx}>
                              <a
                                className="Link u-textSecondary u-block u-paddingVert2gu u-textSizeMsrp1"
                                href={link.link[0]?.string}
                                target="_blank"
                                rel="noreferrer"
                                dangerouslySetInnerHTML={{
                                  __html: link.text,
                                }}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    {inner.innerLabel && (
                      <div className="Accordion Accordion--ruled">
                        <details
                          className="Accordion-item"
                          open={
                            inner.innerLabel
                              .replaceAll(' ', '')
                              .replaceAll('.', '')
                              .toLowerCase() === expand.inner
                          }
                        >
                          <summary
                            id={inner.innerLabel
                              .replaceAll(' ', '')
                              .replaceAll('.', '')
                              .toLowerCase()}
                            className="Accordion-toggle u-textSizeMsrp1 fund-portfolio-name"
                          >
                            {inner.innerLabel}
                          </summary>

                          <div className="Accordion-content Content u-paddingTop0">
                            <div className="Grid Grid--withGutter">
                              <div
                                className="u-size2of3"
                                dangerouslySetInnerHTML={{
                                  __html: inner.innerContent,
                                }}
                              ></div>
                              <div className="u-size1of3">
                                {inner.innerLink?.text &&
                                  renderMainSubscribeButton(
                                    subscriptions,
                                    inner
                                  )}
                              </div>
                              {inner.innerLinkList.links.length !== 0 && (
                                <div className="Grid u-marginTop3gu">
                                  <div className="u-size1of2">
                                    <h2 className="u-textSizeMsrp1">
                                      {inner.innerLinkList.tableHeader}
                                    </h2>
                                  </div>
                                  <div className="u-size1of2 u-textRight">
                                    <p className="">Email Updates</p>
                                  </div>
                                </div>
                              )}
                              {inner.innerLinkList.links.map((link, idx) => (
                                <div
                                  key={idx}
                                  className={`Grid u-paddingHoriz0 u-marginHoriz2gu ${
                                    inner.innerLinkList.links.length === idx + 1
                                      ? ''
                                      : 'underline'
                                  }`}
                                >
                                  <div className="u-size1of2">
                                    <a
                                      className="Link u-textSecondary u-block u-paddingTop3gu u-textSizeMsrp1"
                                      href={getFileLink(link.link[0])}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {link.text}
                                    </a>
                                  </div>
                                  <div className="u-size1of2 u-textRight">
                                    <div
                                      className="u-marginTop3gu u-textTight"
                                      data-fund-name={inner.innerLabel}
                                      data-literature-type={
                                        link.text
                                          ?.toLowerCase()
                                          .includes('commentary')
                                          ? 'Commentary (PDF)'
                                          : link.text
                                      }
                                    >
                                      {subscriptions &&
                                        subscriptions.length > 0 &&
                                        renderSubscribeButton(
                                          link,
                                          inner.innerLabel,
                                          inner.innerLinkList.links
                                        )}
                                    </div>
                                  </div>
                                </div>
                              ))}
                              {inner.contentBlock.length !== 0 && (
                                <div className="u-marginVert3gu">
                                  {inner.contentBlock.map(
                                    (block) =>
                                      block && (
                                        <div key={idx}>
                                          {block.value && (
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html: block.value,
                                              }}
                                            ></div>
                                          )}
                                          {block.links &&
                                            block.links.map((link, idx) => (
                                              <div
                                                key={idx}
                                                className="u-size2of3"
                                              >
                                                <a
                                                  className="Link u-textSecondary u-block u-paddingTop1gu"
                                                  href={link.link[0]?.string}
                                                  target="_blank"
                                                  rel="noreferrer"
                                                >
                                                  {link.text}
                                                </a>
                                              </div>
                                            ))}
                                        </div>
                                      )
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </details>
                      </div>
                    )}
                  </div>
                )
              })}
            </details>
          ))}
        </div>
      </div>
    </div>
  ) : (
    <div className="u-bgColorOffwhite" style={{ width: '100%', height: 600 }}>
      <Loader />
    </div>
  )
}

function Highlander(Component) {
  let immortals = 0

  return function (props) {
    const [onlyOne, thereIsOnlyOne] = useState(false)
    useEffect(() => {
      immortals++
      if (immortals === 1) {
        thereIsOnlyOne(true)
      }
      ;() => {
        immortals--
      }
    }, [])
    return <Component {...props} onlyOne={onlyOne} />
  }
}

export const Accordion = Highlander(Accordions)
